<template lang="html">
    <div>
        <app-layout :loading="loading">
            <div slot="title" v-if="apiUser.id > 0">
                Api Kullanıcısı Güncelle
            </div>
            <div slot="title" v-if="apiUser.id == 0">
                Api Kullanıcısı Ekle
            </div>
            <div slot="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="box">
                            <div class="box-body">
                                <div v-for="item in formMessages">
                                    <div class="alert" :class="'alert-' + item.type">
                                        {{ item.message }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Açıklama</label>
                                    <input type="text" class="form-control" v-model="apiUser.name" />
                                </div>
                                <div class="form-group">
                                    <label>Açık Anahtar</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="apiUser.publicKey" />
                                        <span class="input-group-btn">
                                            <button class="btn btn-secondary" type="button" v-on:click="generatePublicKey">Yenile</button>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Özel Anahtar</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="apiUser.privateKey" />
                                        <span class="input-group-btn">
                                            <button class="btn btn-secondary" type="button" v-on:click="generatePrivateKey">Yenile</button>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>İzin Verilen Bildirimler</label>
                                    <select2 :data="events"
                                             :selected="apiUser.events"
                                             v-on:onChange="onApiUserEventChanged" />
                                </div>
                                <div class="form-group">
                                    <label>İzin Verilen Servisler</label>
                                    <select2 :data="services"
                                             :selected="apiUser.allowedServices"
                                             v-on:onChange="onApiUserAllowedServicesChanged" />
                                </div>
                                <div class="form-group">
                                    <label>Öntanımlı Servis</label>
                                    <select2 :data="services"
                                             :selected="apiUser.service"
                                             :maxSelection="1"
                                             :minSelection="0"
                                             v-on:onChange="onApiUserServiceChanged" />
                                </div>
                                <div class="form-group">
                                    <label>Durumu</label>
                                    <div class="checkbox">
                                        <label><input type="checkbox" v-model="apiUser.status" /> Aktif</label>
                                    </div>
                                </div>
                                <div class="form-actions">
                                    <button type="button" v-on:click="submit" :disabled="saving" class="btn btn-success">
                                        <span v-if="saving == false">Kaydet</span>
                                        <span v-if="saving">Lütfen bekleyiniz...</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </app-layout>
    </div>
</template>

<script>
import $ from 'jquery';
import parallel from 'async/parallel';
import _values from 'lodash.values';
import AppLayout from '../components/app_layout.vue';
import Select2 from '../components/select.v2.vue';

function uuid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
}

export default {
    components: {
        'app-layout': AppLayout,
        'select2': Select2
    },
    data: function () {
        return {
            apiUser: {
                id: 0,
                name: '',
                publicKey: uuid(),
                privateKey: uuid(),
                events: [],
                service: [],
                allowedServices: [],
                status: false
            },
            loading: true,
            saving: false,
            formMessages: [],
            events: [],
            services: []
        }
    },
    mounted: function () {
        var $this = this;
        parallel([
            function (next) {
                $this.$app.get('/api/v1/events/all', function(xhr) {
                    var response = xhr.responseJSON;
                    $this.events = $.map(response.events, function (event) {
                        return {
                            id: event.id,
                            text: event.name
                        }
                    });
                    next();
                });
            },
            function (next) {
                $this.$app.get('/api/v1/services/all', function(xhr) {
                    var response = xhr.responseJSON;
                    $this.services = $.map(response.services, function (service) {
                        return {
                            id: service.id,
                            text: service.name
                        }
                    });
                    next();
                });
            },
            function (next) {
                var id = $this.$router.currentRoute.query.id;
                if (id > 0) {
                    $this.$app.get('/api/v1/api-users/' + id, function(xhr) {
                        var response = xhr.responseJSON;
                        $this.apiUser.id = response.apiUser.id;
                        $this.apiUser.name = response.apiUser.name;
                        $this.apiUser.publicKey = response.apiUser.publicKey;
                        $this.apiUser.privateKey = response.apiUser.privateKey;
                        $this.apiUser.events = _values(response.apiUser.events);
                        $this.apiUser.allowedServices = _values(response.apiUser.allowedServices);
                        $this.apiUser.status = response.apiUser.status;
                        $this.apiUser.service = parseInt(response.apiUser.serviceId) > 0 ? [response.apiUser.serviceId] : [];
                        next();
                    });
                } else {
                    next();
                }
            }
        ], function (err, results) {
            $this.loading = false;
        });
    },
    methods: {
        submit: function (e) {
            var $this = this;
            this.saving = true;
            var params = {
                id: this.apiUser.id,
                name: this.apiUser.name,
                public_key: this.apiUser.publicKey,
                private_key: this.apiUser.privateKey,
                events: this.apiUser.events,
                allowed_services: this.apiUser.allowedServices,
                service_id: this.apiUser.service.length > 0 ? this.apiUser.service[0] : 0,
                status: this.apiUser.status ? 1 : 0
            };
            $this.$app.post('/api/v1/api-users', params, function (xhr) {
                var data = xhr.responseJSON;
                if (data.formMessages != undefined) {
                    $this.formMessages = data.formMessages
                }
                if (data.meta.httpStatusCode == 200) {

                } else if (data.meta.httpStatusCode == 201) {
                    $this.apiUser = {
                        id: 0,
                        name: '',
                        publicKey: uuid(),
                        privateKey: uuid(),
                        events: [],
                        allowedServices: [],
                        service: 0,
                        status: false
                    };
                }
                $this.saving = false;
                window.scrollTo(0, 0);
            });
        },
        generatePrivateKey: function () {
            this.apiUser.privateKey = uuid();
        },
        generatePublicKey: function () {
            this.apiUser.publicKey = uuid();
        },
        onApiUserEventChanged: function (data) {
            this.apiUser.events = data;
        },
        onApiUserAllowedServicesChanged: function (data) {
            this.apiUser.allowedServices = data;
        },
        onApiUserServiceChanged: function (data) {
            this.apiUser.service = data;
        }
    },
    watch: {
        '$route': function () {
            if (this.$router.currentRoute.query.id == undefined) {
                this.apiUser = {
                    id: 0,
                    name: '',
                    publicKey: uuid(),
                    privateKey: uuid(),
                    events: [],
                    allowedServices: [],
                    service: [],
                    status: false
                };
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// api_user_save.vue?2f66be85